export default __webpack_public_path__ + "locales/hy-AM/FilesSettings.json?hash=c24e9ca576c8ddfea4d11403b0562640";